/**
 * @file 认证按钮
 * @author
 */

import React, {Fragment, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Button} from 'antd';
import AuthModal from './authFormModal';
import {recordProxy} from '../../util';
import './form.less';

interface Props {
    name: string;
    type?: string;
}
export default function AuthButton(props: Props) {
    const {pathname} = useLocation();
    const {name, type} = props;
    const [showModal, setShowModal] = useState(false);

    const btnType = {
        '立即申请': 'bannerBtn',
        '立即认证': 'bannerBtn',
        '了解更多优势': 'advantageBtn',
        '了解更多功能': 'featuresBtn',
        '获取您的专属方案': 'casesBtn',
        '了解更多价值': 'worthBtn',
    };
    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
            document.body.addEventListener('touchmove', freezeVp, false);
        } else {
            document.body.style.overflow = 'auto';
            document.body.removeEventListener('touchmove', freezeVp, false);
        }
    }, [showModal]);
    const hideModal = () => {
        setShowModal(false);
    };
    const freezeVp = function(e) {
        e.preventDefault();
    };
    const onBtnClick = () => {
        setShowModal(true);
        recordProxy(pathname.replace('/', ''), 'click', btnType[name]);
    };

    const buttonClassName = () => {
        let classNameValue = '';
        switch (type) {
            case 'banner-btn':
                classNameValue = 'carousel-item-btn';
                break;
            default:
                classNameValue = 'auth-button';
        }
        return classNameValue;
    };

    return (
        <Fragment>
            <Button
                className={buttonClassName()}
                type="primary"
                onClick={onBtnClick}>{name}</Button>
            <AuthModal
                {...props}
                source={btnType[name]}
                open={showModal}
                onOk={hideModal}
                onCancel={hideModal}
            />
        </Fragment>
    );
}
